import React from 'react';
import useReviews from '../../hooks/useReviews/useReviews';
import './Reviews.css'
const Reviews = () => {
    const [reviews, setReviews] = useReviews();
    return (
        <div>
            <h1> Here, You can see our book lover's Review</h1>
            {reviews.map(review => <div>
                <div className='review-head'><img className='profile-img' src={review.img} alt={`profile pic of - ${review.name}`} />
                    <h1>{review.name}</h1>
                  
                </div>
                <p>{review.reviewText}</p>
                <h3> <span>User Ratings: </span><small>{review.rating}</small></h3>
            </div>)}

        </div>
    );
};

export default Reviews;
